import axios from '@/plugins/axios';
import SystemConst from '@/shared/system-const';
import { TableFilters } from '@/components/common/common-table-filter.component';

export default {
    namespaced: true,

    state: {
        // 一覧画面用
        /** ページ */
        page: 1,

        /** 表示件数 */
        itemsPerPage: SystemConst.LIST_LINES_PER_PAGE[1],

        /** フィルター条件 */
        filters: {},

        /** ソートカラム */
        sortBy: [],

        /** ソート昇順、降順 */
        sortDesc: [],

        /** 詳細画面からの遷移フラグ */
        isFromDetail: false
    },
    mutations: {
        /** セッター：state.page */
        setPage(state: any, page: number) {
            state.page = page;
        },

        /** セッター：state.itemsPerPage */
        setItemsPerPage(state: any, itemsPerPage: number) {
            state.itemsPerPage = itemsPerPage;
        },

        /** セッター：state.filters */
        setFilters(state: any, filters: TableFilters) {
            state.filters = filters;
        },

        /** セッター：state.sortBy */
        setSortBy(state: any, sortBy: string[]) {
            state.sortBy = sortBy;
        },

        /** セッター：state.sortDesc */
        setSortDesc(state: any, sortDesc: boolean[]) {
            state.sortDesc = sortDesc;
        },

        /** セッター：state.isFromDetail */
        setIsFromDetail(state: any, isFromDetail: boolean) {
            state.isFromDetail = isFromDetail;
        },

        /** 
         * ユーザー処理状況管理ストアのクリア
         * 
         * @param state ステートオブジェクト
         */
        clearStoreState(state: any) {
            state.page = 1;
            state.itemsPerPage = SystemConst.LIST_LINES_PER_PAGE[1];
            state.filters = {};
            state.sortBy = [];
            state.sortDesc = [];
            state.isFromDetail = false;
        }
    },
    actions: {
        // 処理状況一覧フィルター情報取得API
        async getFilterConditions() {
            // resultの初期化
            let result: any;

            // URL:GET /api/processing-status-users/filter-conditions
            // params: なし
            await axios.get('/api/processing-status-users/filter-conditions')
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;

                });

            // 通信結果を返す
            return result;
        },

        // 処理状況詳細フィルター情報取得API
        async getDetailFilterConditions() {
            // resultの初期化
            let result: any;

            // URL:GET /api/processing-status-users/detail/filter-conditions
            // params: なし
            await axios.get('/api/processing-status-users/detail/filter-conditions')
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;

                });

            // 通信結果を返す
            return result;
        },

        // 処理状況一覧取得API
        async getProcesses({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // URL:GET /api/processing-status-users
            // params:ページ番号
            //        １ページあたりの行数
            //        ソートキー
            //        ソート順
            //        フィルタ情報
            await axios.get('/api/processing-status-users', {
                params: {
                    page: data.page,
                    itemsPerPage: data.itemsPerPage,
                    sortKey : data.sortKey,
                    sortOrder : data.sortOrder,
                    filterParams : data.filterParams
                }
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;

                });

            // 通信結果を返す
            //   processingStatusUsers[]
            //   totalCount
            //   HTTPステータスコード
            return result;
        },

        // EXCEL出力API
        async outputExcel({ state, commit, rootState }: any, data: any) {
            // Excelファイル名の格納
            const fileName = data.fileName;

            // resultの初期化
            let result: any;

            // URL:GET /api/processing-status-users/{processId}/excel
            // params:中間処理ID
            await axios.get(`/api/processing-status-users/${data.processId}/excel`,
                {
                    // レスポンスのバイナリデータをarraybufferで受け取る
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;

                // レスポンス結果のバイナリデータが存在する場合、Excelファイルを作成する
                if (response.data) {
                    // レスポンス結果のバイナリデータをBlobオブジェクトにする
                    const blob = new Blob([response.data]);

                    // BlobオブジェクトのURLオブジェクトを作成する
                    const objURL: string = window.URL.createObjectURL(blob);

                    // エレメントを作成し、要素にURLオブジェクトとダウンロードするファイル名を格納する
                    const dlLink: HTMLAnchorElement = document.createElement('a');
                    dlLink.href = objURL;
                    dlLink.download = fileName;

                    // 親のHTMLのbody要素に子ノードを追加し、作成した要素を追加する
                    document.body.appendChild(dlLink);

                    // 追加した子ノードの要素に対してクリックイベントを起こし、ファイルをダウンロードする
                    dlLink.click();

                    // 子ノードを削除する
                    document.body.removeChild(dlLink);
                }
            })
            .catch((error) => {
                // 通信結果を設定（エラー）
                result = error.response;

                // ArrayBuffer型のエラーメッセージデータを16進数の文字コードの配列に変換する
                const errorMessage = Array.from(new Uint8Array(error.response.data));

                // 作成した文字コードを文字列に変換し、JSON形式に変換する
                result.data = JSON.parse(String.fromCharCode.apply("", errorMessage));
            });

            // 通信結果を返す
            //   HTTPステータスコード
            return result;
        },

        // 処理中の処理状況確認API
        async getRunningStatus({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // URL:GET /api/processing-status-users/{processId}/check
            // params:中間処理ID
            await axios.get(`/api/processing-status-users/${data.processId}/check`)
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;

                });

            // 通信結果を返す
            //   count（指定の中間処理IDが実行中である件数）
            //   HTTPステータスコード
            return result;
        },

        // 処理状況削除API
        async deleteProcess({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // URL:DELETE /api/processing-status-users/:processId
            // params:中間処理ID
            await axios.delete(`/api/processing-status-users/${data.processId}`, {
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;

                });

            // 通信結果を返す
            //   HTTPステータスコード
            return result;
        },

        // 処理状況詳細一覧取得API
        async getProcessDetails({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // URL:GET /api/processing-status-users/{processId}
            // params: 中間処理ID
            //         ページ番号
            //         １ページあたりの行数
            //         ソートキー
            //         ソート順
            //         フィルタ情報
            await axios.get(`/api/processing-status-users/${data.processId}`, {
                params: {
                    page: data.page,
                    itemsPerPage: data.itemsPerPage,
                    sortKey : data.sortKey,
                    sortOrder : data.sortOrder,
                    filterParams : data.filterParams
                }
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;

                });

            // 通信結果を返す
            //   processingStatusUserDetails[]
            //   totalCount
            //   HTTPステータスコード
            return result;
        }
    }
}
